module.exports = __webpack_public_path__ + "img/TADAa.a1b84f7a.png";